export default function getResource(label, vars = []) {
    const resources = {
        allRewards: 'All Rewards',
        addFullSize: 'Add Full Size',
        rougeBadge: 'ROUGE',
        freeShipping: 'Get FREE shipping on 750+ rewards, no purchase required',
        '50 Points': '50 Points',
        '100 Points': '100 Points',
        '200-499 Points': '200+ Points',
        '250-499 Points': '250+ Points',
        '500-749 Points': '500+ Points',
        '750-2999 Points': '750+ Points',
        '3000-4999 Points': '3000+ Points',
        '5000-19999 Points': '5000+ Points',
        '20000+ Points': '20000+ Points'
    };
    return resources[label];
}
